import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'shared-dev-button',
    styleUrls: ['./dev-button.shared.component.scss'],
    template: `<button class="dev-tools__btn -type-ft"><span class="dev-tools__btn-label"><ng-content></ng-content></span></button>`,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DevButtonComponent { }
